import styled from "styled-components";

export const Container = styled.div`
	margin-bottom: 5em;

	.desktop-title {
		font-size: 1.125em;
		text-transform: uppercase;
	}

	form {
		label {
			display: flex;
			flex-direction: column;
			row-gap: 5px;
			margin-bottom: 1em;
			width: 100%;

			p {
				font-size: 1em;
				margin: 0;
			}

			input,
			select {
				padding-left: 1em;
				height: 45px;
				border: 1px solid #d9d9d9;
				width: 100%;
			}

			&.inputChecked {
				flex-direction: row;
				margin-top: 1em;

				input {
					width: 20px;
					height: 20px;
					margin-right: 10px;
				}
			}

			span.require {
				color: tomato;
				font-size: 14px;
				padding-top: 2px;
			}
		}

		label.termsOfUser {
			display: flex;
			flex-direction: row;

			input[type="checkbox"] {
				width: 20px;
				height: 20px;
				margin-right: 10px;
			}
		}
	}
`;

export const LabelContainer = styled.label`
	label {
		display: flex;
		flex-direction: column;
		row-gap: 5px;
		margin-bottom: 1em;
		width: 100%;

		p {
			font-size: 1em;
			margin: 0;
		}

		input,
		select {
			padding-left: 1em;
			height: 45px;
			border: 1px solid #d9d9d9;
			width: 100%;
		}

		&.inputChecked {
			flex-direction: row;
			margin-top: 1em;

			input {
				width: 20px;
				height: 20px;
				margin-right: 10px;
			}
		}

		span.require {
			color: tomato;
			font-size: 14px;
			padding-top: 2px;
		}
	}
`;

export const GroupInput = styled.div`
	display: flex;
	align-items: flex-start;

	&.flex-center {
		align-items: center;
	}

	&.flex-end {
		align-items: flex-end;
	}

	label {
		flex: 1 1 0;

		& + label {
			margin-left: 1em;
		}
	}

	a {
		font-weight: bold;
		flex: 1 1 0;
		margin-left: 1em;
	}
`;
